// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/package_providers_features_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { PackageProviderFeaturesResponse } from './package_provider_features_response_pb';
import { file_responses_v1_package_provider_features_response } from './package_provider_features_response_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/package_providers_features_response.proto.
 */
export const file_responses_v1_package_providers_features_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjZyZXNwb25zZXMvdjEvcGFja2FnZV9wcm92aWRlcnNfZmVhdHVyZXNfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSJfCiBQYWNrYWdlUHJvdmlkZXJzRmVhdHVyZXNSZXNwb25zZRI7CgRkYXRhGAEgAygLMi0ucmVzcG9uc2VzLnYxLlBhY2thZ2VQcm92aWRlckZlYXR1cmVzUmVzcG9uc2VCkAEKEGNvbS5yZXNwb25zZXMudjFCJVBhY2thZ2VQcm92aWRlcnNGZWF0dXJlc1Jlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw',
        [file_responses_v1_package_provider_features_response]
    );

/**
 * @generated from message responses.v1.PackageProvidersFeaturesResponse
 */
export type PackageProvidersFeaturesResponse = Message<'responses.v1.PackageProvidersFeaturesResponse'> & {
    /**
     * @generated from field: repeated responses.v1.PackageProviderFeaturesResponse data = 1;
     */
    data: PackageProviderFeaturesResponse[];
};

/**
 * Describes the message responses.v1.PackageProvidersFeaturesResponse.
 * Use `create(PackageProvidersFeaturesResponseSchema)` to create a new message.
 */
export const PackageProvidersFeaturesResponseSchema: GenMessage<PackageProvidersFeaturesResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_package_providers_features_response, 0);
